import { resourceState, resourceMutations } from '@/store/utils/resource';
import { LINKS } from '@/store/entities/schema_types';
import { linksClient as client } from '@/api/clients';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: {
    //
  },
  actions: {
    async store(ctx, { body }) {
      try {
        const response = await client.store(body);

        const { data } = response.data;

        const id = await ctx.dispatch(
          'entities/persistEntities',
          { type: LINKS, data },
          { root: true }
        );

        return Promise.resolve({ id });
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async update(ctx, { id, body }) {
      try {
        const response = await client.update(id, body);

        const { data } = response.data;

        await ctx.dispatch('entities/persistEntities', { type: LINKS, data }, { root: true });

        return Promise.resolve({ id });
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async destroy(ctx, { id }) {
      try {
        await client.destroy(id);

        ctx.commit(
          {
            type: 'entities/removeEntity',
            entityId: id,
            entityType: LINKS,
          },
          { root: true }
        );

        return Promise.resolve({ id });
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
